import type { QueryHookOptions } from "@apollo/client";
import { gql, useQuery } from "@apollo/client";

import type { PlanIngredient, Ingredient, Variant } from "@shared/types/graphqlGenerated";

const ProductDailyIntake_ClinicShared_Query = gql`
  query ProductDailyIntake_ClinicShared_Query($id: ID!, $amount: String, $frequency: String) {
    viewer {
      variant: node(id: $id) {
        ... on Variant {
          id
          productDailyIntake(amount: $amount, frequency: $frequency) {
            childIngredients {
              dosage
              dosageUnit
              alternativeDosage
              alternativeDosageUnit
              ingredient {
                id
                name
              }
            }
            dosage
            dosageUnit
            alternativeDosage
            alternativeDosageUnit
            ingredient {
              id
              name
            }
            productNames
            productCount
          }
        }
      }
    }
  }
`;

type PlanIngredientSplinter = Pick<
  PlanIngredient,
  | "dosage"
  | "dosageUnit"
  | "alternativeDosage"
  | "alternativeDosageUnit"
  | "productNames"
  | "productCount"
>;
type IngredientSplinter = Pick<Ingredient, "id" | "name">;
type VariantSplinter = Pick<Variant, "id">;

interface ChildIngredient extends PlanIngredientSplinter {
  ingredient: IngredientSplinter;
}

interface DailyIntake extends PlanIngredientSplinter {
  childIngredients: ChildIngredient[];
  ingredient: IngredientSplinter;
}

interface VariantShard extends VariantSplinter {
  productDailyIntake: DailyIntake[];
  errors: {
    message: string;
  };
}

interface ProductDailyIntakeData {
  viewer: {
    variant: VariantShard;
  };
}

interface Variables {
  id: string;
  amount?: string;
  frequency?: string;
}

const useProductDailyIntakeQuery = (
  options?: QueryHookOptions<ProductDailyIntakeData, Variables>
) => useQuery<ProductDailyIntakeData, Variables>(ProductDailyIntake_ClinicShared_Query, options);

export type { ProductDailyIntakeData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useProductDailyIntakeQuery, ProductDailyIntake_ClinicShared_Query, type DailyIntake };
